module.exports = __webpack_public_path__ + "img/ctt48-icon.7641d108.png";